export type FormationValues =
  | 'CAP'
  | 'BAC_GENERAL'
  | 'CPGE'
  | 'IUT'
  | 'PARAMEDIC'
  | 'UNIVERSITY'
  | 'GRANDE_ECOLE'
  | 'OTHER';

export const formations: FormationValues[] = [
  'CAP',
  'BAC_GENERAL',
  'CPGE',
  'IUT',
  'PARAMEDIC',
  'UNIVERSITY',
  'GRANDE_ECOLE',
  'OTHER',
];

enum FORMATIONS {
  CAP = 'CAP, BEP, bac pro',
  BAC_GENERAL = 'Bac général',
  CPGE = 'En classe préparatoire aux grandes écoles',
  PARAMEDIC = 'Dans une école du paramédical, du social',
  IUT = 'En IUT, BTS, ou licence professionnelle',
  UNIVERSITY = 'À l’université (hors IUT et Licence professionnelle)',
  GRANDE_ECOLE = 'Dans une grande école (commerce/management, Sciences Po, ingénieur, art...)',
  OTHER = 'Autre',
}
export default FORMATIONS;
